import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import shippingApi from "../api/shippingApi";
import GHTK from "../consts/ghtk";

// create slice
const name = "shipping";
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const shippingActions = { ...slice.actions, ...extraActions };
export const shippingReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    lstShipping: [],
    isCreate: false,
    notes: [],
    key: null,
  };
}

function createExtraActions() {
  return {
    getShipping: getShipping(),
  };

  function getShipping() {
    return createAsyncThunk(
      `${name}/getShipping`,
      async () => await shippingApi.getShipping()
    );
  }
}

function createExtraReducers() {
  return {
    ...getShipping(),
  };

  function getShipping() {
    const { pending, fulfilled, rejected } = extraActions.getShipping;
    return {
      [pending]: (state) => {
        state.lstShipping = [GHTK];
      },
      [fulfilled]: (state, action) => {
        const data = action.payload;
        state.lstShipping = data === null || data.length === 0 ? [GHTK] : data;
        state.notes = data === null || data.length === 0 ? [] : data[0].notes;
        state.isCreate = data === null || data.length === 0 ? false : true;
        state.key = data === null || data.length === 0 ? GHTK.key : data[0].key;
      },
      [rejected]: (state, action) => {
        state.lstShipping = [GHTK];
      },
    };
  }
}
